


function moduleSlider(){

	var prevArrow = '/wp-content/themes/rhubarb-duplo/library/images/prev.svg';	
	var nextArrow = '/wp-content/themes/rhubarb-duplo/library/images/next.svg';	

	$('.slider-slick').slick({
		dots: true,
		arrows:true,
		infinite: true,
		autoplay:true,
		speed: 300,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: '10%',
		variableWidth: true, 
		nextArrow: "<div class='slick-arrow slick-next' style='background-image: url("+ nextArrow +");'></div>",
		prevArrow: "<div class='slick-arrow slick-prev' style='background-image: url("+ prevArrow +");'></div>",		
	});

}